import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { _cs } from '@togglecorp/fujs';
import { IoClose, IoResize, IoAdd, IoRemove, IoTabletPortraitSharp } from '../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo } from '../../utils/index.js';
import { useButtonFeatures } from '../Button/index.js';
import Modal from '../Modal/index.js';
import PendingMessage from '../PendingMessage/index.js';
import useBooleanState from '../../hooks/useBooleanState.js';
import styles from './styles.css.js';

var _PendingMessage, _IoClose, _IoResize, _IoAdd, _IoRemove, _IoTabletPortraitShar;

function ImagePreview(props) {
  const {
    className,
    src,
    alt,
    hideTools,
    disableZoomOnScroll
  } = props;
  const [expanded,, setExpandedFalse,, toggleExpanded] = useBooleanState(false);
  const [pending, setPendingTrue, setPendingFalse] = useBooleanState(true); // NOTE: not using img.onloadstart because it's not supported in react and
  // chrome
  // https://github.com/facebook/react/issues/20330

  useEffect(() => {
    setPendingTrue();
  }, [setPendingTrue, src]);
  const buttonProps = useButtonFeatures({
    className: styles.toolButton,
    variant: 'action',
    disabled: pending
  });
  const children = /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles.imagePreview)
  }, pending && (_PendingMessage || (_PendingMessage = /*#__PURE__*/React.createElement(PendingMessage, null))), /*#__PURE__*/React.createElement(TransformWrapper, {
    wheel: {
      step: 0.2,
      wheelDisabled: disableZoomOnScroll
    },
    centerZoomedOut: true,
    centerOnInit: true,
    minScale: 0.2,
    maxScale: 8
  }, _ref => {
    let {
      zoomIn,
      zoomOut,
      resetTransform
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideTools && /*#__PURE__*/React.createElement("div", {
      className: styles.tools
    }, /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
      onClick: () => toggleExpanded(),
      title: expanded ? 'Close fullscreen' : 'View fullscreen',
      type: "button"
    }), expanded ? _IoClose || (_IoClose = /*#__PURE__*/React.createElement(IoClose, null)) : _IoResize || (_IoResize = /*#__PURE__*/React.createElement(IoResize, null))), /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
      onClick: () => zoomIn(),
      title: "Zoom in",
      type: "button"
    }), _IoAdd || (_IoAdd = /*#__PURE__*/React.createElement(IoAdd, null))), /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
      onClick: () => zoomOut(),
      title: "Zoom in",
      type: "button"
    }), _IoRemove || (_IoRemove = /*#__PURE__*/React.createElement(IoRemove, null))), /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
      onClick: () => resetTransform(),
      title: "Reset zoom",
      type: "button"
    }), _IoTabletPortraitShar || (_IoTabletPortraitShar = /*#__PURE__*/React.createElement(IoTabletPortraitSharp, null)))), /*#__PURE__*/React.createElement(TransformComponent, {
      wrapperClass: styles.wrapper
    }, /*#__PURE__*/React.createElement("img", {
      key: src,
      onLoad: setPendingFalse,
      onError: setPendingFalse,
      className: styles.image,
      src: src,
      alt: alt
    })));
  }));

  if (expanded) {
    return /*#__PURE__*/React.createElement(Modal, {
      heading: null,
      onCloseButtonClick: setExpandedFalse,
      bodyClassName: styles.body,
      size: "cover"
    }, children);
  }

  return children;
}

var index = genericMemo(ImagePreview);

export { index as default };
//# sourceMappingURL=index.js.map
